<template>
  <div>
    <h1>Contact</h1>
    <p>
      Unmatched Maker was created by and is maintained by me, Jonathan Guberman
      (A. Square).
    </p>
    <p>
      I'd love to hear from you for (almost) any reason: bug reports, feature
      requests, or just to say hi.
    </p>
    <dl class="row">
      <dt class="col-lg-2 col-md-3 col-sm-4">Email</dt>
      <dd class="col-lg-10 col-md-9 col-sm-8">jonathan@unmatched.cards</dd>

      <dt class="col-lg-2 col-md-3 col-sm-4">Discord</dt>
      <dd class="col-lg-10 col-md-9 col-sm-8">
        <code>A. Square#0371</code> on the
        <a href="https://discord.gg/DZDHn8U">Unmatched Maker</a>
        and
        <a href="https://discord.gg/j4k8VWv">official Restoration</a>
        servers
      </dd>
      <dt class="col-lg-2 col-md-3 col-sm-4">BoardGameGeek</dt>
      <dd class="col-lg-10 col-md-9 col-sm-8">
        <a href="https://boardgamegeek.com/user/ASquare">ASquare</a>
      </dd>
    </dl>
    <p>
      You can also file bug reports and feature requests, or comment on existing
      bugs and planned features, at the Unmatched Maker
      <a href="https://github.com/JonathanGuberman/unmatched_maker/issues"
        >Github page</a
      >.
    </p>
  </div>
</template>

<script>
export default {
  name: "Contact",
  metaInfo: {
    title: "Contact"
  }
};
</script>
